module.exports = __webpack_public_path__ + "img/lang-26.a942005f.jpg";